const SERVICE = {
  sitePlan: [
    {
      name: 'basic',
      pageLimit: 3,
      couponLimit: null,
      order: true,
      account: {
        admin: 1,
        normal: 0
      },
      payment: null, // free
      localinfo: true,
      guidebook: true, // dgb
      channelguide: true,
      analytics: 0 // 0: 페이지 분석, 1: 페이지 분석, 방문객 분석
    },
    {
      name: 'standard',
      pageLimit: null,
      couponLimit: null,
      order: true,
      account: {
        admin: 1,
        normal: 10
      },
      /**
       * 3,000원 / 객실
       * 매달 결제
       */
      payment: {
        term: 'month', // 결제기간
        price: 3000, // 결제금액
        currency: 'krw', // 결제금액 단위
        per: 'room' // 결제 기준 대상
      },
      localinfo: true,
      guidebook: true,
      channelguide: true,
      analytics: 1
    },
    {
      name: 'premium',
      pageLimit: null,
      couponLimit: null,
      order: true,
      account: {
        admin: 1,
        normal: 20
      },
      payment: {
        term: 'month',
        price: 5000,
        currency: 'krw',
        per: 'room'
      },
      localinfo: true,
      guidebook: true,
      channelguide: true,
      analytics: 1
    }
  ],
  payment: {
    discount: { // 할인율
      yearly: 30, // 연간결제시
      guidbook: 20
    }
  },
  userRole: [
    'admin',
    'manager',
    'staff',
    'guest'
  ]
}

export default SERVICE
